// Sync status in the header. Shown ONLY when something is not yet on the server:
// syncing, offline with a pending count, or queued. Silent when all is synced.
import { Icon, IconAlert, IconCloudUpload, IconRefresh } from "@traveldiary/ui";
import { useApp } from "../state/app";

export function SyncBadge() {
  const { sync, t } = useApp();

  // Synced is the resting state, so it carries no information: a badge that is
  // always on stops being read within a day and permanently spends header room.
  // Brian asked for it gone. The states below stay, because "something has not
  // reached the server yet" is the only sync fact a traveller can act on.
  if (sync.state === "synced") {
    return null;
  }

  if (sync.state === "syncing") {
    return (
      <span className="sync" role="status">
        <Icon size={16}>
          <IconRefresh />
        </Icon>
        <span>{t("sync.syncing")}</span>
      </span>
    );
  }

  if (sync.state === "offline") {
    return (
      <span className="sync sync-warn" role="status">
        <Icon size={16}>
          <IconAlert />
        </Icon>
        <span>
          {t("sync.offline")} {sync.pending}
        </span>
      </span>
    );
  }

  return (
    <span className="sync" role="status">
      <Icon size={16}>
        <IconCloudUpload />
      </Icon>
      <span>
        {t("sync.pending")} {sync.pending}
      </span>
    </span>
  );
}
